const CaseStatusForUserDropDown = {
    CaseCreatedWithoutFiles: {id: 1, title: "არ არის შევსებული", titleForInternalUser: "არ არის შევსებული"},
    CaseCreatedWithFiles: {id: 2, title: "განხილვის პროცესშია", titleForInternalUser: "განხილვის პროცესშია"},
    Approved: {id: 3, title: "დასრულებულია - დადებითი პასუხი", titleForInternalUser: "დასრულებულია - დადებითი პასუხი", forInternalUser: true, color: "green"},
    Declined: {id: 4, title: "დახარვეზებულია", titleForInternalUser: "დახარვეზებულია"},
    FinishedDenied: {id: 8, title: "დასრულებულია - უარი ნებართვაზე / უარი რეგისტრაციაზე", titleForInternalUser: "დასრულებულია - უარი ნებართვაზე / უარი რეგისტრაციაზე", forInternalUser: true, color: "red"},
    Invalid: {id: 9, title: "გამოცხადდა ძალადაკარგულად", titleForInternalUser: "გამოცხადდა ძალადაკარგულად"},
    ConditionalEnded: {id: 10, title: "დასრულებულია პირობით", titleForInternalUser: "დასრულებულია პირობით", forInternalUser: false, color: "#d1ac28"},
    Exploitation: {id: 12, title: "მოთხოვნა ექსპლოატაციაში მიღებაზე", titleForInternalUser: "მოთხოვნა ექსპლოატაციაში მიღებაზე"},
    Unexamined: {id: 14, title: "განუხილველი", titleForInternalUser: "განუხილველი"},
    Postponed: {id: 15, title: "ვადაგარძელებული", titleForInternalUser: "ვადაგარძელებული"},
    Sent: {id: 17, title: "გაგზავნილია", titleForInternalUser: "გაგზავნილია"},
    expertCase: {id: 18, title: "შიდა განაცხადი", titleForInternalUser: "შიდა განაცხადი"},
};

export default CaseStatusForUserDropDown;


